import { Button } from "@mui/material";
import { makeStyles } from "@mui/styles";
import PropTypes from "prop-types";

const useStyles = makeStyles((theme) => ({
  root: {
    "&.MuiButton-root": {
      fontSize: 14,
      fontWeight: 400,
      textTransform: "none",
      color: "black",
      "&:hover": {
        background: "none",
      },
    },
  },
}));

export function LinkButton(props) {
  const classes = useStyles();
  const { children, onClick } = props;

  return (
    <Button className={classes.root} onClick={onClick}>
      {children}
    </Button>
  );
}

LinkButton.propTypes = {
  onClick: PropTypes.func,
};
